import { EpimsBaseEntityDto } from './epim-base.dto';

export class LandUseStatusDto extends EpimsBaseEntityDto {

    LandUseStatusId: string;

    LandUseStatusName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}